import { routingActions } from '../config/actions';

const defaultState = {
  isLoading: false,
  data: [],
  new: null,
  created: false,
  updated: false,
  error: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case routingActions.ROUTING_IS_LOADING:
      return {
        ...state,
        isLoading: true,
        data: state.data || false,
        created: state.created,
        error: null,
        new: null
      };
    case routingActions.ROUTING_ERROR:
      return {
        ...state,
        isLoading: false,
        data: state.data || [],
        created: false,
        error: action.error,
        new: null
      };
    case routingActions.ROUTING:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        created: false,
        error: null,
        new: state.routing || []
      };
    case routingActions.ROUTING_NEW:
      return {
        ...state,
        isLoading: true,
        data: state.data,
        created: false,
        error: null,
        new: action.data
      };
    default:
      return state;
  }
};
